export default __webpack_public_path__ + "static/media/run-above.ce2c241b.svg";